import React from 'react';
import QuickFilter from './quickFilter/QuickFilter';
import {
    StyledQuickFiltersContainer,
    StyledQuickFilterGrid,
    StyledQuickFilterIcon,
} from './QuickFilters.styled';
import ArrowDownReverse from 'src/pages/orders/components/arrowDownReverse/ArrowDownReverse';

const QuickFilters = ({
    showFilterIcon,
    filterClick,
    quickFilterList,
    showFullFilter,
    filterActiveId,
    filterSwitch,
}) => {
    // quickFilterList = quickFilterList?.map((filter) => {
    //     if (filter.id === 1) {
    //         return {
    //             ...filter,
    //             count: orderList?.length,
    //         };
    //     }
    //     return {
    //         ...filter,
    //         count: orderList?.filter((order) => {
    //             return order.orderStatusDescription === filter.label;
    //         })?.length
    //             ? orderList?.filter((order) => {
    //                   return order.orderStatusDescription === filter.label;
    //               })?.length
    //             : 0,
    //     };
    // });

    return (
        <StyledQuickFiltersContainer>
            <StyledQuickFilterGrid>
                <StyledQuickFilterIcon
                id="orders-quickfilters-toggle-icon"
                    isShowIcon={showFilterIcon}
                    onClick={filterClick}
                >
                    <ArrowDownReverse
                        width={'20%'}
                        height={'20%'}
                        isOpen={showFullFilter}
                    />
                </StyledQuickFilterIcon>
                {quickFilterList.map((filtr) => {
                    return !filtr.isExcluded ? (
                        <React.Fragment key={filtr.id}>
                            <QuickFilter
                                label={filtr.label}
                                count={filtr.count}
                                id={filtr.id}
                                showFullFilter={showFullFilter}
                                isFilterActive={filterActiveId === +filtr.id}
                                filterSwitch={filterSwitch}
                            />
                        </React.Fragment>
                    ) : filtr.count > 0 ? (
                        <React.Fragment key={filtr.id}>
                            <QuickFilter
                                label={filtr.label}
                                count={filtr.count}
                                id={filtr.id}
                                showFullFilter={showFullFilter}
                                isFilterActive={filterActiveId === +filtr.id}
                                filterSwitch={filterSwitch}
                            />
                        </React.Fragment>
                    ) : null;
                })}
            </StyledQuickFilterGrid>
        </StyledQuickFiltersContainer>
    );
};
export default QuickFilters;
